<template>
    <div class="em_box" :class="{'inputfocus':inputfocus,'em_mini':miniType}" :style="'width:'+comWidth+'px'">
        <div class="em_btn em_right" @mouseenter="inputfocus=true" @mouseleave="inputfocus=false" @click="setone(-1)">
            <i class="el-icon-minus"></i>
        </div>
        <input v-if="isMoney" v-model="datainfo[dataKey]" type="number" :style="'width:'+getwidth+'px'" autocomplete="off" @focus="inputfocus=true" @blur="inputfocus=false" @input="setone()"/>
        <input v-else v-model="datainfo[dataKey]" :class="{'suffix_exist':suffix!=''}" :style="'width:'+getwidth+'px'" autocomplete="off" @focus="inputfocus=true" @blur="inputfocus=false" @input="setone()"/>
        <div  class="em_btn em_left" @mouseenter="inputfocus=true" @mouseleave="inputfocus=false" @click="setone(1)">
            <i class="el-icon-plus"></i>
        </div>
        <div class="suffixfont" style="color: #409eff;" v-if="showPlus">{{suffix+'+'}}</div>
        <div class="suffixfont" v-else>{{suffix}}</div>
    </div>
</template>
<script>
import {checkNumberPlus,checkMoneyPlus} from './infunc.js'
export default {
    props:{
        datainfo:{
            type:Object,
            default:function(){
                return {};
            }
        },
        dataKey:{
            type:String,
            default:'',
        },
        isMoney:{
            type:Boolean,
            default:false,
        },
        maxValue:{
            type:Number,
            default:1000000000,
        },
        miniType:{
            type:Boolean,
            default:false,
        },
        comWidth:{
            type:Number,
            default:180,
        },
        showPlus:{
            type:Boolean,
            default:false,
        },
        suffix:{
            type:String,
            default:'',
        }
    },
    data(){
        return{
            inputfocus:false,
        }
    },
    computed:{
        getwidth:function(){
            if(this.miniType){
                return this.comWidth-56;
            }else{
                return this.comWidth-80;
            }
        }
    },
    methods:{
        setone:function(val){
            if(!val){
                val = 0;
            }
            let nowval = 0;
            if(this.isMoney){
                nowval = checkMoneyPlus(this.datainfo[this.dataKey]+"",val,this.maxValue);
            }else{
                nowval = checkNumberPlus(this.datainfo[this.dataKey],val,this.maxValue);
            }
            this.$emit('changeEnd',nowval);
        }
    }
}
</script>

<style lang='scss' scoped>
.em_box:hover{
    border-color: #c0c4cc;
}
.em_box.inputfocus{
    border-color: #409eff;
}
.em_box.em_mini{
    height: 28px;
    .em_btn{
        font-size: 12px;
        width: 28px;
        height: 28px;
        line-height: 26px;
    }
    .suffixfont{
        line-height: 26px;
        right: 35px;
    }
}
.em_box{
    position: relative;
    display: flex;
    width: 180px;
    height: 40px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    input{
        box-sizing: border-box;
        border: none;
        outline: 0;
        text-indent: 5px;
        padding-top: 2px;
    }
    .em_btn{
        width: 40px;
        height: 40px;
        background: #f5f7fa;
        box-sizing: border-box;
        cursor: pointer;
        line-height: 40px;
        text-align: center;
        font-size: 13px;
        color: #606266;
    }
    .em_btn:hover{
        color:#409eff;
    }
    .em_right{
        border-right:1px solid #DCDFE6;
        border-radius:4px 0 0 4px;
    }
    .em_left{
        border-left:1px solid #DCDFE6;
        border-radius:0 4px 4px 0;
    }
    .suffixfont{
        position: absolute;
        right: 45px;
        top: 0px;
        line-height: 38px;
        font-size: 14px;
    }
}
.suffix_exist{
    padding-right: 35px;
}
</style>